<div
  id="form-summary"
  class="popup-add ${!appService.isAutoRateValid ? 'invalid-autorate' : ''}"
>
  <span if.bind="appService.isAutoRateValid"
    ><h2>COVERAGE <span>SUMMARY</span></h2></span
  >
  <span if.bind="!appService.isAutoRateValid"
    ><h2 style="background-color: #cc0000">RATE <span>FAILED</span></h2></span
  >
  <div
    class="summary-content popup-content ${!appService.isAutoRateValid ? 'invalid-autorate' : ''}"
  >
    <div show.bind="appService.isAutoRateValid">
      <h3 if.bind="appService.premiumModel.auTotalClientPremium > 0">
        $<span class="summary-price">${appService.premiumModel.auTotalClientPremium.toFixed(2).split('.')[0] | currencyFormat:'(0,0)'}</span>${'.' + appService.premiumModel.auTotalClientPremium.toFixed(2).split('.')[1]}
      </h3>
      <h3 else>
        $<span class="summary-price">0</span>.00
      </h3>

      <div id="summary-details">
        <table class="cost-table" if.bind="appService.premiumModel.premium > 0">
          <tr if.bind="appService.premiumModel.premium > 0">
            <td class="item">Premium</td>
            <td class="value">
              ${appService.premiumModel.premium.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.fsl > 0">
            <td class="item">FSL</td>
            <td class="value">
              ${appService.premiumModel.fsl.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.stampDuty > 0">
            <td class="item">Stamp Duty</td>
            <td class="value">
              ${appService.premiumModel.stampDuty.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.schemeFees.insurerAdminFee > 0">
            <td class="item">Insurer Admin Fee</td>
            <td class="value">
              ${appService.premiumModel.schemeFees.insurerAdminFee.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.schemeFees.adviserAdminFee > 0">
            <td class="item">Adviser Admin Fee</td>
            <td class="value">
              ${appService.premiumModel.schemeFees.adviserAdminFee.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.schemeFees.adminFee > 0">
            <td class="item">Admin Fee</td>
            <td class="value">
              ${appService.premiumModel.schemeFees.adminFee.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.schemeFees.adjustmentValue > 0">
            <td class="item">Less Adjustment Value</td>
            <td class="value">
              ${appService.premiumModel.schemeFees.adjustmentValue.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.totalGst > 0">
            <td class="item">Total GST</td>
            <td class="value">
              ${appService.premiumModel.totalGst.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
          <tr if.bind="appService.premiumModel.auTotalClientPremium > 0">
            <td class="item">Total</td>
            <td class="value">
              ${appService.premiumModel.auTotalClientPremium.toFixed(2) |
              currencyFormat:'($0,0.00)'}
            </td>
          </tr>
        </table>
      </div>

      <h4
        id="summary-content-expand"
        toggle="target-element: #summary-details; width-direction: >; width-constraint: 980;"
      >
        see cost breakdown
        <span><img src.bind="arrowDown" alt="arrow-down" /></span>
      </h4>
      <div id="summary-details" class="active">
        <div class="policies">
          <template repeat.for="[key, summary] of appService.summaryQuestions">
            <h5 if.bind="$first">your policy details</h5>
            <h6>
              ${summary.label}
              <span>${summary.value | currencyFormat:'($0,0)'}</span>
            </h6>
          </template>
        </div>
      </div>
    </div>

    <div if.bind="!appService.isAutoRateValid">
      <div id="summary-details" class="active">
        <ul
          repeat.for="error of appService.autoRateErrors"
          style="list-style-type: none; padding: 0; margin: 0"
        >
          <li style="color: #cc0000">${error}</li>
        </ul>
        <div>
          <p style="color: #cc0000">Quote could not be rated.</p>
          <p style="color: #000000">
            For assistance, please <a href="mailto:${email}" external>email</a>
          </p>
          <p style="color: #000000">${adviser} or call</p>
          <p style="color: #000000">${phone}</p>
        </div>
      </div>
    </div>
  </div>
</div>
